import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'//首页
import Index from '@/components/Index'//主页
import twoSystem from '@/components/twoSystem'//2大体系
import fourFeature from '@/components/fourFeature'//4大功能
import eightPlate from '@/components/eightPlate'//8大板块
import developmentPlanning from '@/components/developmentPlanning'//8大板块
import newsCenter from '@/components/newsCenter'//新闻中心
import socialResponsibility from '@/components/socialResponsibility'//社会责任  
import aboutUs from '@/components/aboutUs'//社会责任
Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: 'home',
			component: home
		},
		{
			path: '/Index',
			name: 'Index',
			component: Index,
			meta:{
			      // true: 侧边栏与顶部栏显示 false: 不显示
			      keepAlive: true
			    }
		},
		{
			path: '/twoSystem',
			name: 'twoSystem',
			component: twoSystem,
			meta:{
			      // true: 侧边栏与顶部栏显示 false: 不显示
			      keepAlive: true
			    }
		},
		{
			path: '/fourFeature',
			name: 'fourFeature',
			component: fourFeature,
			meta:{
			      // true: 侧边栏与顶部栏显示 false: 不显示
			      keepAlive: true
			}
		},
		{
			path: '/eightPlate',
			name: 'eightPlate',
			component: eightPlate,
			meta:{
			      // true: 侧边栏与顶部栏显示 false: 不显示
			      keepAlive: true
			}
		},
		{
			path: '/developmentPlanning',
			name: 'developmentPlanning',
			component: developmentPlanning,
			meta:{
			      // true: 侧边栏与顶部栏显示 false: 不显示
			      keepAlive: true
			}
		},
		{
			path: '/newsCenter',
			name: 'newsCenter',
			component: newsCenter,
			meta:{
			      // true: 侧边栏与顶部栏显示 false: 不显示
			      keepAlive: true
			}
		},
		{
			path: '/socialResponsibility',
			name: 'socialResponsibility',
			component: socialResponsibility,
			meta:{
			      // true: 侧边栏与顶部栏显示 false: 不显示
			      keepAlive: true
			}
		},
		{
			path: '/aboutUs',
			name: 'aboutUs',
			component: aboutUs,
			meta:{
			      // true: 侧边栏与顶部栏显示 false: 不显示
			      keepAlive: true
			}
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js